<template>
    <div class="outbox">
        <div class="headerbox">
            <div class="searchbox">
                <el-input style="height:45px" clearable placeholder="搜索联盟客名称" v-model="params.receiverName"
                    @change="searchData">
                    <i slot="prefix" class="el-input__icon el-icon-search"></i>
                </el-input>
            </div>
            <div class="filiter"><img src="@/assets/img/mobile/shaixuan.png" alt="" @click="filiterShow = true"></div>
        </div>

        <div class="infinite-list-wrapper">
            <div class="scrollbox" :infinite-scroll-distance="10" v-infinite-scroll="scrollData"
                infinite-scroll-disabled="disabled" infinite-scroll-immediate="false">
                <el-card shadow="never" class="box-card" v-for="item in emaiList" :key="item.id">
                    <div class="affitem" @click="goDetail(item.id)">
                        <span v-if="item.isRead == '0'" class="readdot"></span>
                        <el-row>
                            <el-col :span="5">
                                <div class="headsrc"> <el-avatar :size="60"
                                        :src="item.headSrc ? item.headSrc : '/default.png'"></el-avatar></div>
                            </el-col>
                            <el-col :span="15">
                                <div class="name"><span class="title">{{ item.name }}</span> <span class="time">{{
                                    item.createTime }}</span></div>
                                <div class="subdesc">{{ item.abstractContent }}</div>
                            </el-col>
                            <el-col :span="4">
                                <div class="goods">
                                    <img v-if="item.isStarMark == 0" src="@/assets/img/emil/kx.png"
                                        @click.stop="starMark(item)">
                                    <img v-if="item.isStarMark == 1" src="@/assets/img/emil/sx.png"
                                        @click.stop="starMark(item)">
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                </el-card>
                <el-divider v-if="loading">加载中...</el-divider>
                <el-divider v-if="noMore && totalpages > 0">没有更多了</el-divider>
                <div class="nodata" v-if="totalpages === 0">
                    <img src="@/assets/img/nodata.png" alt="">
                    <div>暂无数据</div>
                </div>
            </div>

        </div>


        <el-drawer :visible.sync="filiterShow" :with-header="false" size="65%">
            <div class="myfiliter">
                <div class="title">
                    是否已读
                </div>
                <el-select v-model="params.isRead" filterable placeholder="请选择" style="height:40px;margin-bottom:8px">
                    <el-option label="全部" value="">
                    </el-option>
                    <el-option label="是" value="1">
                    </el-option>
                    <el-option label="否" value="0">
                    </el-option>
                </el-select>
                <div class="title">
                    开始日期
                </div>
                <el-date-picker v-model="params.startDate" type="date" value-format="yyyy-MM-dd" placeholder="选择开始日期"
                    style="width: 100%;height:40px;margin-bottom:8px">
                </el-date-picker>
                <div class="title">
                    结束日期
                </div>
                <el-date-picker v-model="params.endDate" type="date" value-format="yyyy-MM-dd" placeholder="选择结束日期"
                    style="width: 100%;height:40px;margin-bottom:8px">
                </el-date-picker>

                <div class="footer">
                    <el-row :gutter="8">
                        <el-col :span="12">
                            <div class="reset"> <el-button type="primary" style="width:100%"
                                    @click="resetFiliter">重置</el-button>
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div class="submit"> <el-button type="primary" style="width:100%"
                                    @click="searchData">确定</el-button></div>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </el-drawer>
    </div>
</template>
<script>
import { EMAILSTARMARKDEAL, QUERYEMAILSENDLIST, EMAILSENDSTARMARK } from '@/api/emial'
import { formatTime } from '@/utils/common'
export default {
    data() {
        return {
            params: {
                currentPage: 1,
                size: 10,
                receiverName: '',
                isRead: '',
                startDate: null,
                endDate: null,
            },
            totalpages: null,
            loading: false,
            emaiList: [],
            filiterShow: false,
        }
    },
    computed: {
        noMore() {
            return this.totalpages == this.params.currentPage
        },
        disabled() {
            return this.loading || (this.totalpages == this.params.currentPage)
        }
    },
    created() {
        this.getData()
    },
    methods: {
        //重置条件
        resetFiliter() {
            this.params = {
                currentPage: 1,
                size: 10,
                receiverName: '',
                isRead: '',
                startDate: null,
                endDate: null,
            }
            this.searchData()
            this.filiterShow = false
        },
        getData() {
            this.loading = true
            QUERYEMAILSENDLIST(this.params).then(res => {
                this.emaiList = []
                this.totalpages = res.data.body.pages
                let arr = res.data.body.records
                this.emaiList = arr
                this.loading = false
            }).catch(err => {
                this.loading = false
            })
        },
        //搜索联盟客
        searchData() {
            this.params.currentPage = 1
            this.getData()
            this.filiterShow = false
        },
        scrollData() {
            this.params.currentPage++
            this.loading = true
            QUERYEMAILSENDLIST(this.params).then(res => {
                this.totalpages = res.data.body.pages
                let arr = res.data.body.records
                this.emaiList = this.emaiList.concat(arr)
                this.loading = false
            }).catch(err => {
                this.loading = false
            })
        },
        starMark(e) {
            EMAILSENDSTARMARK({ id: e.id }).then(res => {
                this.$message({
                    message: '操作成功',
                    type: 'success'
                });
                this.searchData()
            })
        },
        goDetail(id) {
            this.$router.push({ path: '/outdetail-m', query: { id: id } })
        }


    }
}
</script>
<style lang="less" scoped>
.outbox {
    height: 100%;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    padding: 53px 8px 8px 8px;
    background-color: #fff;

    /deep/.el-card__body {
        padding: 8px !important;
    }

    .headerbox {
        display: flex;
        position: fixed;
        top: 58px;
        width: calc(100% - 16px);
        background-color: #fff;
        z-index: 10;

        .searchbox {
            flex: auto;
        }

        .filiter {
            padding: 5px;

            img {
                width: 35px;
                height: 35px;
            }
        }
    }

    .infinite-list-wrapper {
        margin-top: 8px;
        height: 100%;

        .scrollbox {
            height: 100%;
            overflow: auto;
        }

        .box-card {
            margin-bottom: 8px;

            .affitem {
                height: 60px;
                position: relative;

                .readdot {
                    position: absolute;
                    left: -3px;
                    top: -3px;
                    content: '';
                    width: 6px;
                    height: 6px;
                    background-color: #be3c6e;
                    border-radius: 50%;
                }

                .headsrc {
                    height: 60px;
                    line-height: 60px;
                }

                .name {
                    position: relative;
                    height: 30px;
                    line-height: 30px;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;

                    .title {
                        position: absolute;
                        width: 110px;
                        left: 0;
                        font-size: 14px;
                        font-weight: 600;
                        color: #303133;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                    }

                    .time {
                        position: absolute;
                        right: 0;
                        font-size: 12px;
                        font-weight: 400;
                        color: #303133;
                    }
                }

                .subdesc {
                    height: 30px;
                    line-height: 30px;
                    font-size: 12px;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }

                .goods {
                    display: flex;
                    height: 60px;
                    flex-direction: row;
                    flex-wrap: nowrap;
                    text-align: center;
                    justify-content: flex-end;
                    align-items: center;

                    img {
                        width: 35px;
                        height: 35px;
                    }
                }
            }
        }

        .nodata {
            margin-top: 45%;
            text-align: center;

            div {
                margin-top: 8px;
                color: #bfbfbf;
            }
        }
    }
}

.myfiliter {
    height: 100%;
    width: 100%;
    padding: 8px;
    position: relative;

    .title {
        font-weight: 600;
        margin-bottom: 8px;
    }

    .footer {
        padding-top: 8px;
        width: calc(100% - 16px);
        position: absolute;
        bottom: 8px;

        .reset {
            width: 100%;
        }

        .submit {
            width: 100%;
        }
    }
}
</style>